<template>
  <div v-title="$route.meta.title">
    <!-- 题目添加面板 -->
    <div class="question-type-container">
      <sj-question :model="questions"
                   :fixed-ids="appendQuestionIds">
        <step-template-question-type :disabled="disabled.add"
                                     v-model="questions"></step-template-question-type>
      </sj-question>
    </div>

    <!-- 模板内容 -->
    <div class="step-template-content-container">
      <!-- 模板信息 -->
      <step-template-info
        ref="infoForm"
        v-model="form" :disabled="disabled.base"></step-template-info>
      <!-- 题目列表 -->
      <step-template-questions
        ref="questionForm"
        v-model="questions"></step-template-questions>
    </div>

    <div class="step-template-right-container"
         :style="{maxHeight: rightHeight + 'px'}">
      <!-- 模板操作面板 -->
      <div ref="stepTemplateAction">
        <layout-panel hide-collapse>
          <template slot="header">
            模板操作
          </template>
          <template slot="tools">
            <el-tooltip content="复制模板数据"
                        placement="top">
              <button class="sj-icon-copy"
                      ref="copyQuestions"></button>
            </el-tooltip>
            <el-dropdown>
              <button class="el-icon-more"></button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="collapseAllQuestion(true)">全部收起</el-dropdown-item>
                <el-dropdown-item @click.native="collapseAllQuestion(false)">全部展开</el-dropdown-item>
                <el-dropdown-item @click.native="openCache">读取缓存</el-dropdown-item>
                <el-dropdown-item @click.native="copyQuestionTo">从其他模板复制题目</el-dropdown-item>
                <el-dropdown-item @click.native="showDataLabelModal">批量设置数据标签</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <!--模板操作-->
          <div v-show="questions.length">
            <sj-question-number v-model="questions"
                                :question-items="sjQuestionItems"
                                :danger-ids="validateFailQuestionIds"
                                :fixed-ids="appendQuestionIds"></sj-question-number>
            <hr class="hr-dashed margin b15">
          </div>
          <el-button type="primary"
                     size="small"
                     v-if="allowSave"
                     :disabled="!questions.length"
                     @click="onSubmit">保存模板
          </el-button>
          <el-button type="info"
                     size="small"
                     plain
                     @click="openTree">逻辑树
          </el-button>
        </layout-panel>
      </div>

      <!-- 题目属性面板 -->
      <template v-show="hasQuestionFocus || hasOptionFocus">
        <div class="step-template-question-attr">
          <!-- 题目属性 -->
          <step-template-question-attr
            v-if="hasQuestionFocus"
            :body-style="{maxHeight: this.questionAttrHeight + 'px'}"
            v-model="focusQuestion"
            :index="focusQuestionIndex"
            :questions="questions"
            :disabled="disabled.base"
            :through_record="form.through_record"
          ></step-template-question-attr>
          <!-- 选项属性 -->
          <step-template-question-option-attr
            v-if="hasOptionFocus"
            :body-style="{maxHeight: this.questionAttrHeight + 'px'}"
            v-model="focusOption"
            :index="focusOptionIndex"
            :questions="questions"
            :question="focusQuestion"
            :question-index="focusQuestionIndex"
            :disabled="disabled.base"
          ></step-template-question-option-attr>
        </div>
      </template>
    </div>

    <!-- 题目发送到模板组件 -->
    <send-question-to ref="SendQuestionTo"
                      :fixed-ids="appendQuestionIds"></send-question-to>
    <copy-question-to ref="CopyQuestionTo"
                      :fixed-ids="appendQuestionIds"></copy-question-to>
    <step-template-data-labels ref="StepTemplateDataLabels"></step-template-data-labels>
    <validate-question-warning ref="ValidateQuestionWarning"></validate-question-warning>
    <check-question-fix ref="CheckQuestionFix"></check-question-fix>
  </div>
</template>

<script>
import SjQuestionNumber from '@/views/question-editor/packages/sj-question-number/src/SjQuestionNumber'
import SjQuestion from '@/views/question-editor/packages/sj-question/src/SjQuestion'
import StepTemplateInfo from '@/views/step-template/components/StepTemplateInfo'
import StepTemplateQuestionAttr from '@/views/step-template/components/StepTemplateQuestionAttr'
import StepTemplateQuestionOptionAttr from '@/views/step-template/components/StepTemplateQuestionOptionAttr'
import StepTemplateQuestions from '@/views/step-template/components/StepTemplateQuestions'
import StepTemplateQuestionType from '@/views/step-template/components/StepTemplateQuestionType'
import { convertQuestions } from '@views/question-editor/format/convert'
import { recoveryQuestions } from '@views/question-editor/format/recovery'
import { TweenLite } from 'gsap/TweenLite'
import draggable from 'vuedraggable'

import QuestionCacheBox from '@/views/question-editor/components/question-cache-box'
import QuestionTreeBox from '@/views/question-editor/components/question-tree-box'
import SendQuestionTo from '@/views/step-template/components/SendQuestionTo'
import appendQuestions from '@/views/step-template/data/step-template-append-questions'
import defaultQuestions from '@/views/step-template/data/step-template-default-questions'
// import StepTemplateValidator from '@/views/step-template/components/StepTemplateValidator'
import checkFix from '@/views/question-editor/utils/checkFix'
import validate from '@/views/question-editor/utils/validate'
import CheckQuestionFix from '@/views/step-template/components/CheckQuestionFix'
import CopyQuestionTo from '@/views/step-template/components/CopyQuestionTo'
import StepTemplateDataLabels from '@/views/step-template/components/StepTemplateDataLabels'
import ValidateQuestionWarning from '@/views/step-template/components/ValidateQuestionWarning'
import ClipboardJS from 'clipboard'

import ImageViewBox from '@/views/question-editor/components/image-view-box'
import QuestionImageUploadBox from '@/views/question-editor/components/question-image-upload-box'
import SjQuestionUploadVideoBox from '@/views/question-editor/packages/sj-question-upload-video-box'
import SjPlyrAudioBox from '@core/components/sj-plyr-audio-box'
import SjPlyrVideoBox from '@core/components/sj-plyr-video-box'

let clipboard
let actionPanelObserver = null
let timer = null

export default {
  components: {
    CheckQuestionFix,
    ValidateQuestionWarning,
    CopyQuestionTo,
    StepTemplateDataLabels,
    SendQuestionTo,
    SjQuestion,
    StepTemplateQuestionOptionAttr,
    SjQuestionNumber,
    StepTemplateQuestionAttr,
    StepTemplateInfo,
    StepTemplateQuestionType,
    StepTemplateQuestions,
    draggable,
  },
  inject: ['scope', 'request', 'create', 'update', 'visibleGuide'],
  provide: function () {
    return {
      page: this,
      playAudio: SjPlyrAudioBox.open,
      playVideo: SjPlyrVideoBox.open,
      playImage: ImageViewBox.open,
      uploadImage: QuestionImageUploadBox.open,
      uploadVideo: SjQuestionUploadVideoBox.open,
    }
  },
  data () {
    let form = {
      title: '',
      detail: '',
      through_record: true,
      through_record_flag: true,
      extended_steps_start: 0,
      has_sneak_photos: false,
    }
    if (this.scope === 'clb') {
      form.salary = 0
      form.points = 0
    }
    return {
      id: 0,
      ownUserId: '',
      cacheKey: 'create',
      form: form,
      questions: [],
      lastQuestions: [],
      defaultQuestionIds: [],
      appendQuestionIds: [],
      // 验证失败的题目列表
      validateFailQuestionIds: [],
      buttons: [
        {
          tip: '上移',
          icon: 'sj-icon-shift-up',
          action: 'up',
        },
        {
          tip: '下移',
          icon: 'sj-icon-shift-down',
          action: 'down',
        },
        {
          tip: '复制',
          icon: 'sj-icon-copy',
          action: 'copy',
        },
        {
          tip: '移除',
          icon: 'el-icon-delete',
          action: 'remove',
        },
      ],
      questionAttrHeight: '',
      sjQuestionItems: [],
      loading: true,
      collapse: {
        base: false,
        guide: false,
      },
      disabled: {
        base: false,
        guide: false,
        add: false,
      },
      visibleUploadVideoBox: false,
    }
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      types: state => state.types,
      focusQuestionIndex: state => state.focusQuestionIndex,
      focusOptionIndex: state => state.focusOptionIndex,
    }),
    ...Vuex.mapState({
      clientHeight: state => state.clientHeight,
      users: state => state.login.user,
    }),
    rightHeight () {
      return this.clientHeight - 106
    },
    focusQuestion () {
      if (this.focusQuestionIndex !== null) {
        return this.questions[this.focusQuestionIndex]
      }
    },
    focusOption () {
      if (this.focusOptionIndex !== null) {
        return this.focusQuestion.options[this.focusOptionIndex]
      }
    },
    hasQuestionFocus () {
      return this.focusQuestion && !this.focusOption
    },
    hasOptionFocus () {
      return this.focusQuestion && this.focusOption
    },
    allowSave () {
      return ['', this.users.id].includes(this.ownUserId) || parseInt(this.users.usertype) === 1 || filter.hasPermission(97)
    },
  },
  watch: {
    questions: {
      handler (val) {
        !this.loading && val.length && QuestionCacheBox.cache('question-editor', this.cacheKey, val)
      },
      deep: true,
    },
    // 开启全程录音后，不能有录音题
    'form.through_record': {
      handler (val) {
        if (val) {
          this.form.through_record_flag = true
        } else {
          this.form.through_record_flag = false
        }
      },
    },
  },
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.onReload()
  },
  created () {
  },
  mounted () {
    this.questionAttrHeight = this.rightHeight - this.$refs.stepTemplateAction.clientHeight - 68
    this.addListenActionPanelStyle()
    this.copyQuestions()
    document.addEventListener('paste', this.pasteQuestions)
  },
  destroyed () {
    this.removeListenActionPanelStyle()
    QuestionCacheBox.destroy()
    QuestionTreeBox.destroy()
    clipboard.destroy()
    document.removeEventListener('paste', this.pasteQuestions)

    SjPlyrAudioBox.destroy()
    SjPlyrVideoBox.destroy()
    ImageViewBox.destroy()
    QuestionImageUploadBox.destroy()
    SjQuestionUploadVideoBox.destroy()
  },
  methods: {
    ...Vuex.mapMutations('questionEditor', ['convertQuestions', 'recoveryNativeQuestions']),
    checkPermission () {
      // 显示任务指引时
      if (this.visibleGuide && !filter.superPermission()) {
        // 97: 编辑分步模板指引权限
        if (!filter.inPermissions(97)) {
          this.disabled.guide = true
          this.collapse.guide = true
        }

        // 用户没有修改模板的权限，或者用户不是模板的作者，则禁用模板的编辑功能
        // 93: 编辑分步模板权限
        if (!filter.inPermissions(93) || !['', this.users.id].includes(this.ownUserId)) {
          this.collapse.base = true
          this.disabled.add = true
          this.disabled.base = true
        }
      }
    },
    /**
     * 复制模板数据到剪切板
     */
    copyQuestions () {
      clipboard = new ClipboardJS(this.$refs.copyQuestions, {
        text: () => {
          return JSON.stringify({
            version: 1,
            date: filter.formatDate(),
            converted: true,
            type: 'questions',
            title: this.form.title,
            detail: this.form.detail,
            data: this.questions,
          })
        },
      })
      clipboard.on('success', () => {
        this.$message({
          message: '复制模板数据成功！',
          type: 'success',
        })
      })
      clipboard.on('error', () => {
        this.$message({
          message: '复制模板数据失败！',
          type: 'error',
        })
      })
    },
    pasteQuestions (event) {
      let paste = (event.clipboardData || window.clipboardData).getData('text')
      try {
        let data = JSON.parse(paste)
        if (data && typeof data === 'object' && data.type === 'questions' && data.data) {
          event.stopPropagation()
          event.preventDefault()
          let title = data.title || '未命名'
          this.$confirm(`发现[${title}]分步模板数据，是否立即写入当前模板？`, '提示', {type: 'warning'}).then(() => {
            if (!data.converted) {
              try {
                data.data = convertQuestions(data.data)
              } catch (e) {
                return this.$message.error('模板数据转换失败，请检查数据正确性！')
              }
            }
            this.questions = data.data
            this.form.title = data.title
            this.form.detail = data.detail
            this.$message.success('模板数据写入成功！')
          })
        }
      } catch (e) {}
    },
    addListenActionPanelStyle () {
      // Create an observer instance linked to the callback function
      actionPanelObserver = new MutationObserver(() => {
        this.computeQuestionAttrStyle()
      })
      // Start observing the target node for configured mutations
      actionPanelObserver.observe(this.$refs.stepTemplateAction, {
        attributes: true, // configure it to listen to attribute changes
        // childList: true,
        subtree: true,
        attributeFilter: ['style', 'class'],
      })
    },
    removeListenActionPanelStyle () {
      // Later, you can stop observing
      actionPanelObserver && actionPanelObserver.disconnect()
    },
    computeQuestionAttrStyle () {
      timer && clearTimeout(timer)
      timer = setTimeout(() => {
        TweenLite.to(this.$data, 0.1, {
          questionAttrHeight: this.rightHeight - this.$refs.stepTemplateAction.clientHeight - 68,
        })
      }, 300)
    },
    openCache () {
      QuestionCacheBox.open('question-editor', this.cacheKey).then((value) => {
        this.questions = value
      })
    },
    openTree () {
      QuestionTreeBox.open('question-editor', this.questions)
    },
    onLoad () {
      // 先重置数据为空，防止数据元素被缓存
      this.questions = []
      let _defaultQuestions = convertQuestions(filter.copyJson(defaultQuestions))
      let _appendQuestions = convertQuestions(filter.copyJson(appendQuestions))
      this.defaultQuestionIds = _defaultQuestions.map(({id}) => id)
      this.appendQuestionIds = _appendQuestions.map(({id}) => id)
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
        this.cacheKey = this.id
      } else {
        this.$nextTick(() => {
          // 等待重置为空的数据渲染完成后再写入默认数据
          this.questions = _defaultQuestions.concat(_appendQuestions)
          this.$nextTick(() => {
            this.loading = false
          })
        })
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    async setForm (id) {
      this.checkPermission()
      this.fetchStepData(id)
    },
    async fetchStepData (id) {
      const originData = await request.page(this.request.detail, {id}).then(({data}) => {
        return data
      })
      filter.setLoop(this.form, originData)

      originData.json = JSON.parse(originData.json)
      this.questions = convertQuestions(originData.json)
      this.ownUserId = originData.adminid
      this.form.through_record = this.form.through_record === '1'
      this.form.through_record_flag = this.form.through_record_flag === '1'
      this.form.has_sneak_photos = this.form.has_sneak_photos === '1'
      this.$nextTick(() => {
        this.loading = false
      })
    },
    getForm () {
      return filter.copyJson({...this.form, json: JSON.stringify(recoveryQuestions(this.questions))})
    },
    onSubmit () {
      let isValid = true
      this.validateFailQuestionIds = []
      // 验证全部的表单
      let forms = [this.$refs.infoForm, this.$refs.questionForm]
      forms.forEach((form) => {
        form.validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
      })
      // 只有有一个验证失败
      if (isValid) {
        // let ret = StepTemplateValidator.StepTemplateValidate(JSON.parse(this.getForm().json))
        // if (!ret) {
        //   this.$message.error(StepTemplateValidator.GetErrorMessage())
        //   return false
        // }

        // 查理宝分步模板 问题别名必填
        if (this.scope === 'clb') {
          let errorNo = []
          this.questions.forEach((question, index) => {
            if (!question.titleAlias) {
              errorNo.push(index + 1)
            }
          })
          if (errorNo.length) {
            return this.$alert(`第${errorNo.join('、')}题的标题别名未填写！`, '提示', {type: 'warning'})
          }
        }

        let submit = () => {
          this.id ? this.update(this.id, this.getForm()) : this.create(this.getForm())
        }
        // 验证题目, 并提示
        let validateSubmit = () => {
          let validateResults = validate.questions(this.questions)
          if (validateResults.length) {
            this.$refs.ValidateQuestionWarning.open(validateResults)
            this.$refs.ValidateQuestionWarning.submit = submit
          } else {
            submit()
          }
        }

        let extendedStepsStart = this.$refs.infoForm.form.extended_steps_start
        // 检查题目错误并提示
        let checkResults = checkFix.test(this.questions, extendedStepsStart)

        if (checkResults.length) {
          this.$refs.CheckQuestionFix.open(checkResults)
          this.$refs.CheckQuestionFix.submit = () => {
            checkFix.fix(checkResults)
            validateSubmit()
          }
        } else {
          validateSubmit()
        }
      } else {
        this.$message.error('提交内容填写不正确！')
      }
    },
    collapseAllQuestion (bool) {
      this.$refs.questionForm.collapse(bool)
    },
    copyQuestionTo () {
      this.$refs.CopyQuestionTo.open(this.questions, ({toIndex, questions}) => {
        if (toIndex !== null) {
          // 添加到 toIndex 题目之后
          toIndex += 1
        } else if (this.questions.length && this.appendQuestionIds.includes(this.questions[this.questions.length - 1].id)) { // 不能添加到固定题目之后
          // 添加到最后一题之前
          toIndex = this.questions.length - 1
        } else {
          // 添加到最后
          toIndex = this.questions.length
        }
        this.questions.splice(toIndex, 0, ...questions)
      })
    },
    showDataLabelModal () {
      this.$refs.StepTemplateDataLabels.open(this.questions, (questions) => {
        for (let m in questions) {
          for (let n in this.questions) {
            if (questions[m].stepId === this.questions[n].stepId) {
              if (questions[m].hasOwnProperty('dataLabel')) {
                this.questions[n].dataLabel = questions[m].dataLabel
                break
              }

              if (questions[m].hasOwnProperty('options') && questions[m].options.length) {
                for (let o in questions[m].options) {
                  for (let p in this.questions[n].options) {
                    if (questions[m].options[o].id === this.questions[n].options[p].id) {
                      this.questions[n].options[p].dataLabel = questions[m].options[o].dataLabel
                      break
                    }
                  }
                }
              }
            }
          }
        }
      })
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
@import '~@core/style/mixin.scss';

.step-template-question-attr {
  .el-form {
    width: 250px;

    .el-form-item {
      margin-bottom: 10px;

      .el-form-item__content {
        & > .el-select, & > .el-input {
          width: 180px;
        }
      }
    }
  }

  .step-template-question-attr-multiple-select {
    // 当多选为一个标签的时候
    .el-tag:first-child:nth-last-child(1) .el-select__tags-text {
      max-width: 116px;
      @include text-ellipsis;
    }

    // 当多选为两个标签的时候
    .el-tag:nth-last-child(2):first-child .el-select__tags-text {
      max-width: 80px;
      @include text-ellipsis;
    }
  }
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.question-type-container {
  position: absolute;
  left: 20px;
  top: 20px;
  width: 100px;
}

.step-template-right-container {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 280px;
}

.step-template-action-container {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 280px;
}

.step-template-content-container {
  position: relative;
  margin-left: 120px;
  margin-right: 300px;
}

.question-attr-container {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 280px;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/pages/StepTemplateWorkspace.vue